import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		height: '100%',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		padding: THEME.spacing.lg,
		boxSizing: 'border-box',
	},
	header: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',
	},
	pageTitle: {
		display: 'flex',
		gap: THEME.spacing.md,
		alignItems: 'center',
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	iconContainer: {
		height: 48,
		width: 48,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: '#DBEAFE',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	actionsContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.md,
	},
	content: {
		marginTop: THEME.spacing.lg,
	},
	filenameCell: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	actionsCell: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
	},
	actionButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: THEME.spacing.xs,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		':hover': {
			backgroundColor: THEME.colors.hover.light,
		},
	},
});
